module.exports = __webpack_public_path__ + "static/media/coursel_asset_1.300fb289.jpg";